<template>
    <TransitionGroup
        enter-active-class="transition-opacity ease-linear duration-300"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity ease-linear duration-300"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        tag="div"
        class="flex -space-x-2 relative z-0 overflow-hidden"
    >
        <img
            v-for="student in selectedStudents"
            :title="student[nameProperty]"
            :key="student[keyProperty]"
            :src="student[imageProperty]"
            class="relative z-30 inline-block h-8 w-8 rounded-full ring-2 ring-white"
            alt=""
        />
    </TransitionGroup>
</template>

<script>
export default {
    name: 'StudentsProfileStackFiltered',
    props: {
        students: {
            type: Array,
            required: true,
        },
        selected: {
            type: Array,
            required: false,
        },
        imageProperty: {
            type: String,
            required: false,
            default: 'avatar_or_default',
        },
        nameProperty: {
            type: String,
            required: false,
            default: 'full_name',
        },
        keyProperty: {
            type: String,
            required: false,
            default: 'id',
        },
    },
    computed: {
        selectedStudents: function () {
            return this.students.filter((s) => this.selected.includes(s[this.keyProperty]));
        },
    },
};
</script>
